import { Injectable, NgModule } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthProvider } from '../auth/auth';
import { App } from 'ionic-angular';
import { LoginPage } from '@pages';

import { Observable } from 'rxjs';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {

  constructor(
    private authProvider: AuthProvider,
    private app: App,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let promiseToken = this.authProvider.getToken();

    return Observable.fromPromise(promiseToken)
      .mergeMap(token => {
        let clonedReq = this.addToken(req, token);

        return next.handle(clonedReq).pipe(
          catchError(error => {
            // Si encontramos un error 401, significa que se inicio
            // sesión en otro dispositivo o vencio esta sesión :(
            if (error instanceof HttpErrorResponse && error.status == 401) {
              this.app.getRootNavs()[0].setRoot(LoginPage);
            }

            return _throw(error);
          })
        );
      });
  }

  addToken(req, token) {
    if (token)  {
      return req.clone({
        setHeaders: {
          'token-api': token || null
        }
      });
    }

    return req;
  }
}

@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true }
  ]
})
export class InterceptorModule { }



// WEBPACK FOOTER //
// ./src/providers/http-interceptor/interceptor.module.ts